import type { Category, Collection } from '../types/product'
import { images } from './images'

export const categories: Category[] = [
  { id: 'sets', title: 'Sets' },
  { id: 'reiniging', title: 'Reiniging' },
  { id: 'scrubtools', title: 'Scrubtools' },
  { id: 'olien', title: 'Oliën' },
  { id: 'bloemenwater', title: 'Bloemenwater' },
  { id: 'make-up-haar', title: 'Make-up & haar' },
  { id: 'geur', title: 'Geur' },
]

export const collections: Collection[] = [
  {
    slug: 'voor-haar',
    title: 'Voor haar',
    intro: 'Omdat iedere vrouw de puurste verzorging verdient.',
    kind: 'audience',
    value: 'haar',
    image: images.her,
  },
  {
    slug: 'voor-hem',
    title: 'Voor hem',
    intro: 'Omdat echte verzorging geen onderscheid maakt.',
    kind: 'audience',
    value: 'hem',
    image: images.him,
  },
  {
    slug: 'bestsellers',
    title: 'Bestsellers',
    intro: 'De producten waar onze klanten steeds weer voor terugkomen.',
    kind: 'badge',
    value: 'bestseller',
    image: images.argan,
  },
  {
    slug: 'nieuw',
    title: 'Nieuw',
    intro: 'Nieuw in onze collectie.',
    kind: 'badge',
    value: 'nieuw',
    image: images.cactus,
  },
  {
    slug: 'cadeaus',
    title: 'Cadeaus',
    intro: 'Stijlvol verpakt om cadeau te geven. Inclusief een gratis kaartje met jouw persoonlijke boodschap.',
    kind: 'badge',
    value: 'cadeau',
    image: images.giftset,
  },
  {
    slug: 'alles',
    title: 'Alle producten',
    intro: 'Het complete assortiment pure Marokkaanse verzorging.',
    kind: 'all',
  },
]
